import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'app/services/api';
import { Observable, Subscription } from 'rxjs';
import * as lodash from 'lodash';
import { element } from '@angular/upgrade/src/common/angular1';
import { AngularFireDatabase } from 'angularfire2/database';

@Component({
  selector: 'app-tournament-manager-team',
  templateUrl: './tournament-manager-team.component.html',
  styleUrls: ['./tournament-manager-team.component.scss']
})
export class TournamentManagerTeamComponent implements OnInit {

  @Input() tournamentId: any;
  @Input() startType: any;
  @Input() createGroupsEvent: Observable<void>;
  @Input() fillGroupsEvent: Observable<void>;
  @Input() resetGroupsEvent: Observable<void>;
  @Output() onTabChange = new EventEmitter();
  @Output() ongroupCreatedChange = new EventEmitter();
  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private fireDatabase: AngularFireDatabase,
  ) { }
  public unallocatedEntriesOriginal = []
  public unallocatedEntries = [];
  public unallocatedTeams = [];
  public unallocatedTeamsOriginal = [];
  public groups = [];
  public tournament: any;
  public val = 500;
  public createGroupsEventSubscription: Subscription;
  public fillGroupsEventSubscription: Subscription;
  public resetGroupsEventSubscription: Subscription;
  public startTypes = [];
  public teeInterval = 10;
  public groupSize = 4;
  public startHoles = [];
  public missing = [];
  public unallocatedLength = 0;
  public unallocatedTeamsLength = 0;
  public openRemoveUnallocatedEntriesModal = false;
  public imageLoader = false;

  isDropAllowed = (dragData: any) => {
    // Resolves to true or false after 1 second
    return Observable.of(dragData > this.val).delay(1000);
  }

  async removeAllGroups(result) {
    this.imageLoader = true;
    for (let i = 0; i < this.groups.length; i++)
    {
      let groupIndex = i;
      if (this.groups.length == 1) // if its last group
      {
        this.tournament.isGroupCreated = false;
        await this.fireDatabase.database.ref(`tournaments/${this.tournamentId}/isGroupCreated`).set(false);
      }
      let group = this.groups[groupIndex];
      let teams = group.teams ? group.teams : [];
      teams.forEach(async event => {
        let entry = event;
        await this.fireDatabase.database.ref(`/tournament-fixtures/${this.tournamentId}/${entry.teamId}/groupId/`).set(null);
      });
      await this.fireDatabase.database.ref(`/tournament-groups/${this.tournamentId}/${group.groupId}`).set(null);
    }
    await this.init();
    this.imageLoader = false;
  }

  onClickRemoveUnallocatedEntries(event)
  {
    this.onTabChange.emit(2);
    this.openRemoveUnallocatedEntriesModal = false;
    $("#RemoveUnallocatedEntriesModal").modal('hide');
  }


  async createGroup(event) {
    this.imageLoader = true;
    let group;
    if(this.missing.length > 0)
    {
      let val = this.missing.shift()-1;
      let starTime = this.tournament.startTime.split(":");
      let hours = +starTime[0];
      let mins = +starTime[1];
      let oldDateObj = new Date();
      oldDateObj.setHours(hours);
      oldDateObj.setMinutes(mins);
      var newDateObj = new Date();
      newDateObj.setHours(hours);
      newDateObj.setMinutes(mins);
      let minutes = (val) * (+this.teeInterval);
      newDateObj.setTime(oldDateObj.getTime() + (minutes * 60 * 1000));
      let hole: number;
      if (this.startType == 3) // shotgun
      {
        let lenn = this.startHoles.length;
        hole = (val%lenn)+1
      }
      else if (this.startType == 2) //1 and 10
      {
        let numberOFGroups = 0;
        if(this.unallocatedTeamsOriginal.length)
        {
          numberOFGroups = Math.ceil(this.unallocatedTeamsOriginal.length/this.groupSize);
        }
        if (val   > (numberOFGroups / 2)) {                                                             /// len
          hole = 10;
        } else hole = 1;
      }
      else { //1 or 10
        hole = this.startType;
      }
      group = {
          name: "Group "+(val   + 1),                                                                   /// len
          hole: hole,
          time: ("0" + (newDateObj.getHours())).slice(-2)+":"+("0" + (newDateObj.getMinutes())).slice(-2),
          players: [

        ]
      }
    }
    else {
      let starTime = this.tournament.startTime.split(":");
      let hours = +starTime[0];
      let mins = +starTime[1];
      let oldDateObj = new Date();
      oldDateObj.setHours(hours);
      oldDateObj.setMinutes(mins);
      var newDateObj = new Date();
      newDateObj.setHours(hours);
      newDateObj.setMinutes(mins);
      let minutes = (this.groups.length) * (+this.teeInterval);
      newDateObj.setTime(oldDateObj.getTime() + (minutes * 60 * 1000));
      let hole: number;
      if (this.startType == 3) // shotgun
      {
        let lenn = this.startHoles.length;
        hole = (this.groups.length%lenn)+1
      }
      else if (this.startType == 2) //1 and 10
      {
        let numberOFGroups = 0;
        if(this.unallocatedTeamsOriginal.length)
        {
          numberOFGroups = Math.ceil(this.unallocatedTeamsOriginal.length/this.groupSize);
        }
        if (this.groups.length   > (numberOFGroups / 2)) {                                                             /// len
          hole = 10;
        } else hole = 1;
      }
      else {
        hole = this.startType;
      }
      group = {
          name: "Group "+(this.groups.length   + 1),                                                                   /// len
          hole: hole,
          time: ("0" + (newDateObj.getHours())).slice(-2)+":"+("0" + (newDateObj.getMinutes())).slice(-2),
          teams: [

        ],
      }
    }
    let key = this.fireDatabase.database.ref(`/tournament-groups/${this.tournamentId}`).push().key;
    let g = await this.fireDatabase.database.ref(`/tournament-groups/${this.tournamentId}/${key}`).set(group);

    // await this.init();
    await this.fetchGroups();
    this.imageLoader = false;
  }

  ngOnDestroy() {
    this.createGroupsEventSubscription.unsubscribe();
    this.fillGroupsEventSubscription.unsubscribe();
    this.resetGroupsEventSubscription.unsubscribe();
  }

  onHoleChange(event, groupIndex)
  {
    let group = this.groups[groupIndex];
    if(!event)
    {
      alert("Please enter valid hole number");
    }
  }

  onTimeChange(event, groupIndex)
  {
    let group = this.groups[groupIndex];
    if(!event)
    {
      alert("Please enter valid time");
    }
  }

  async updateGroup(groupIndex) {

    let group = this.groups[groupIndex];
    let groupId = group.groupId;
    delete group.groupId;
    delete group.noPlayer;
    delete group.noOfPlayers;
    let teams: any = {};
    group.teams.forEach(team => {
      teams[""+team.teamId] = true;
    });
    group.teams = teams
    this.fireDatabase.database.ref(`/tournament-groups/${this.tournamentId}/${groupId}`).update(group);
  }

  async onRemoveEntryFromGroup(event, groupIndex, teamIndex) //need modification
  {
    this.imageLoader = true;
    let entry;
    if (groupIndex > -1 && teamIndex > -1) {
      entry = this.groups[groupIndex].teams[teamIndex];
      this.groups[groupIndex].teams.splice(teamIndex, 1);
    }
    this.fireDatabase.database.ref(`/tournament-fixtures/${this.tournamentId}/${entry.teamId}/groupId`).set(null);
    await this.updateGroup(groupIndex);
    await this.init();
    this.imageLoader = false;
  }

  onRemoveUnallocatedPlayer(event, player) {
    this.openRemoveUnallocatedEntriesModal = true;
    $("#RemoveUnallocatedEntriesModal").modal('show');
  }

  async onRemoveGroup(event, groupIndex) {

    // remove all users entries for that group put them in unassigned entries
    // then remove group
    this.imageLoader = true
    if(this.groups.length == 1) // if its last group
    {
      this.tournament.isGroupCreated = false;
      await this.fireDatabase.database.ref(`/tournaments/${this.tournamentId}/isGroupCreated`).set(false);
      this.ongroupCreatedChange.emit(false);
    }
    let group = this.groups[groupIndex];
    let teams = group.teams ? group.teams : [];
    teams.forEach(async event => {
      let entry = event;
      await this.fireDatabase.database.ref(`/tournament-fixtures/${this.tournamentId}/${entry.teamId}/groupId/`).set(null);
    });
    await this.fireDatabase.database.ref(`/tournament-groups/${this.tournamentId}/${group.groupId}`).set(null);
    await this.init();
    this.imageLoader = false
  }

  async fetchGroups() {
  let groups = await this.apiService.object(
      `/tournament-groups/${this.tournamentId}`
  );
    let fetchGroupName = [];
    let max = -1;
    this.groups = [];
    if(groups.$exists())
    {
      for (let groupId in groups)
      {
        let noOfPlayers = 0;
        let group = groups[groupId];
        group.groupId = groupId;
        let groupNumber= +group.name.slice(6);
        if(max < groupNumber) max = groupNumber;
        fetchGroupName.push(groupNumber);
        Object.assign(group, { groupId: groupId });
        if (!group.teams)
        {
          Object.assign(group, { players: [] });
        }
        else
        {
          let teams = [];
          lodash.forEach(group.teams, async (value, teamKey) => {
            let players = [];
            this.unallocatedTeamsOriginal.forEach(async team => {
              if (teamKey == team.teamId)
              {
                teams.push(team);
                noOfPlayers = team.teamPlayers.length + noOfPlayers;
              }
            });
          });
          group.teams = teams
        }
         group.noPlayer = [];
        for (let i = 0; i < (this.groupSize - noOfPlayers); i++)
        {
          group.noPlayer.push(0);
        }
        group.noOfPlayers = noOfPlayers;
        this.groups.push(group);
      }

      let avail = [];
      for (let i = 0; i < max; i++)
      {
        avail.push(i + 1);
      }

      this.missing = avail.filter(x => fetchGroupName.indexOf(x) === -1);
    }
  }


    async fillGroups(type) {
    if(this.groups.length==0) {
      alert("Atleast create one group")
      return
    }
    this.imageLoader = true;
    if (type != 1) {
      alert("not available right now");
    }
    else // only random
    {
      
      for (let k = this.groupSize; k > 0; k--) {
        let entries = this.unallocatedTeams.filter(result => {
          return !result.groupId && result.teamPlayers.length == k;
        });
        
        for(let i = 0; i < this.groups.length && entries.length > 0;) 
        {
          let playersToFill = this.groupSize - this.groups[i].noOfPlayers;          
          if (playersToFill >= k) {
            let team = entries.shift();
            if (team) {
              this.groups[i].noOfPlayers = team.teamPlayers.length + this.groups[i].noOfPlayers;
              await this.addTeamInGroup(team, i);
            }
          }
          else i++;
        }
      }
    }

    await this.init()
    this.imageLoader = false;
  }

  async createDefaultGroups(data) {
    this.groupSize = +data.groupSize;
    this.startType = +data.startType;
    this.teeInterval = data.teeInterval;
    this.tournament.isGroupCreated = true;
    let numberOFGroups = 0;
    
    if(this.unallocatedTeamsOriginal.length)
    {
      numberOFGroups = Math.ceil((this.unallocatedTeamsOriginal.length * this.tournament.teamPlay )/data.groupSize);
    }

    let listEntries = [];
    let listGroups = [];
    this.unallocatedTeamsOriginal.forEach(team => {
      listEntries.push(team.teamPlayers.length ? team.teamPlayers.length : 0);
    });

    for (let i = 0; i < numberOFGroups; i++){
      let obj = { noOfPlayers: 0 };
      listGroups.push(obj)
    }

    for(let k = this.groupSize; k > 0; k--) {
        let entries = this.unallocatedTeams.filter(result => {
          return !result.groupId && result.teamPlayers.length == k;
        });
        
        for(let i = 0; i < listGroups.length && entries.length > 0;) 
        {
          let playersToFill = this.groupSize - listGroups[i].noOfPlayers;          
          if (playersToFill >= k) {
            let team = entries.shift();
            if (team) {
              listGroups[i].noOfPlayers = team.teamPlayers.length + listGroups[i].noOfPlayers;
            }
          }
          else i++;
        }
    }

    numberOFGroups = listGroups.filter(group => {
      return group.noOfPlayers;
    }).length
    

    for(let i = 0; i < numberOFGroups; i++){
      await this.createGroup(null);
    }
  }

  async ngOnInit() {
    this.createGroupsEventSubscription = this.createGroupsEvent.subscribe(async (result) => {
      await this.createDefaultGroups(result);
    });

    this.fillGroupsEventSubscription = this.fillGroupsEvent.subscribe(async (result) => {
      this.fillGroups(result);
    });

    this.resetGroupsEventSubscription = this.resetGroupsEvent.subscribe(async (result) => {
      this.tournament.isGroupCreated = false;
      await this.removeAllGroups(result);
    });

    this.tournament = await this.apiService.object(
      `/tournaments/${this.tournamentId}`
    );
    //group creation data
    switch (this.tournament.holesPart) {
        case 1:
          for (let i = 0; i < 9; i++) {
            this.startHoles.push(i + 1);
          }
          this.startType = 1;

          break;
        case 2:
          for (let i = 9; i < 18; i++) {
            this.startHoles.push(i + 1);
          }
          this.startType = 10;
          break;
        default:
          for (let i = 0; i < 18; i++) {
            this.startHoles.push(i + 1);
          }
          this.startType = 1;
          break;
      }

    this.groupSize = +this.tournament.groupSize ? this.tournament.groupSize: 4;
    this.startType = +this.tournament.startType ? +this.tournament.startType: this.startType;
    this.teeInterval = this.tournament.teeInterval ? this.tournament.teeInterval: 10;
 
    await this.init();
  }

  async init() {
    let tournamentPlayers = await this.apiService.object(`/tournament-fixtures/${this.tournamentId}`);
    let teams = [];
    if(tournamentPlayers.$exists()) {
      for(let teamKey in tournamentPlayers)
      {
        let team = tournamentPlayers[teamKey];
        let groups = team.groups ? team.groups : {};
        let players = team.players ? team.players : [];
        let manualPlayers = team.manual_players ? team.manual_players : [];
        let teamPlayers = [];
        for(let manualPlayerKey in manualPlayers)
        {
          let manualPlayer = manualPlayers[manualPlayerKey];
          let obj = manualPlayer;
          Object.assign(obj, { isManual: true, teamId: teamKey, key: manualPlayerKey, handicapsOriginal: this.handicapPrecision(team["handicapsOriginal"][manualPlayerKey]), tournamentHandicap: this.handicapPrecision(team["tournamentHandicap"][manualPlayerKey]) });
          teamPlayers.push(obj);
        }

        for(let PlayerKey in players)
        {
          let player = await this.apiService.object(`users/${PlayerKey}`);
          let obj = player;
          Object.assign(obj, { isManual: false, teamId: teamKey, key: PlayerKey, handicapsOriginal: this.handicapPrecision(team["handicapsOriginal"][PlayerKey]), tournamentHandicap: this.handicapPrecision(team["tournamentHandicap"][PlayerKey]) });
          teamPlayers.push(obj);
        }
        teamPlayers.sort((b, a) => {
          if (a.isPro && b.isPro) {
            if (a.key === teamKey) {
              return 1
            }
            else if (b.key === teamKey) {
              return -1;
            }
            else return 0;
          }
          else if (a.isPro && b.key === teamKey) {
            
            return 1
          }
          else if (b.isPro) {
            return -1
          } else return 0;
        });
        let obj = { teamId: teamKey, teamPlayers: teamPlayers, teamName: team.name };
        if (team.groupId)
        {
          Object.assign(obj, { groupId: team.groupId });
        }
        teams.push(obj);
      }
      this.unallocatedTeams = teams;
      this.unallocatedTeamsOriginal = teams;
      this.unallocatedLength = 0;
      this.unallocatedTeamsLength = this.unallocatedTeams.filter(team => { return !team.groupId }).length;
      await this.fetchGroups();
    }    
  }

  async onItemDrop(event: any, groupIndex: any, unallocatedEntryIndex) {
    let data = event.dragData;

    if((this.groups[groupIndex].teams == undefined|| this.groups[groupIndex].teams) && this.groups[groupIndex].noOfPlayers+data.teamPlayers.length <= this.groupSize) // need to check player count per group
    {
      this.addTeamInGroup(data, groupIndex);
    }
    else alert("Maximum Group size exceeded!");
  }

  async addTeamInGroup(data, groupIndex) {
    this.imageLoader = true;
      if(!this.groups[groupIndex].teams) this.groups[groupIndex].teams = []
      this.groups[groupIndex].teams.push(data);
      await this.fireDatabase.database.ref(`/tournament-fixtures/${this.tournamentId}/${data.teamId}/startHole/`).set(this.groups[groupIndex].hole);
      await this.fireDatabase.database.ref(`/tournament-fixtures/${this.tournamentId}/${data.teamId}/groupId/`).set(this.groups[groupIndex].groupId);
      await this.updateGroup(groupIndex); // manage remove or add entries from here
      await this.init();
      this.imageLoader = false;
  }

  handicapPrecision(handicap)
  {
    return handicap.toFixed(1);
  }
}
